
import $ from "jquery"

function VPFindTerms(jsonString) {
	try {
		jsonString = jsonString.replace(/\\/g, "\\\\")
		var parsedJson = JSON.parse(jsonString)
	} catch(err) {
		//alert("Invalid Search Term");
		jsonString = jsonString.replace(/\\/g, "\\\\")
		var parsedJson = JSON.parse(jsonString)

	}
	var bSelectAll = false
	var bCaseSensitive = false
	var regex = false

	if(parsedJson["messagetype"] === "clearall") {
		//remove all highlights;
		//console.log($(document.body).find("span.found").text());
		$(document.body).find("span.found").replaceWith(function() {
			return $(this).text()
		})
		clearResults()
	} else {
		var searchTerm = buildSearchTerm(parsedJson["searchterm1"], parsedJson["operator1"], parsedJson["searchterm2"], parsedJson["operator2"], parsedJson["searchterm3"], parsedJson["wholeword"], parsedJson["regex"])

		var strTestMatchFlags = "i"
		if(parsedJson["matchcase"] == 1) {
			bCaseSensitive = true
			strTestMatchFlags = ""
		}
		if(parsedJson["messagetype"] === "findnext") {
			var index = 0
			//get current match location
			var matches = $(document.body).find("span.found.highlight")
			//if more than one clear highlights and start at top
			if(matches.length > 1) {
				$(document.body).find("span.found").replaceWith(function() {
					return $(this).text()
				})
				clearResults()
			}
			//if one then get location
			else if(matches.length === 1) {
				//check if search term is the same
				var testSearchTerm = new RegExp(searchTerm, strTestMatchFlags)
				var testSearch = testSearchTerm.test($(document.body).find("span.found.highlight").text())
				if(testSearch) {
					//get data-index and add 1
					index = parseInt(matches[0].getAttribute("data-index")) + 1
					//deselect previous and select new
					$(document.body).find("span.found").replaceWith(function() {
						return $(this).text()
					})
				} else {
					$(document.body).find("span.found").replaceWith(function() {
						return $(this).text()
					})
					clearResults()
				}


			}
			$("body").findWord(searchTerm, bCaseSensitive, true)
			try {
				var test = $(document.body).find("span.found")
				$(test[index]).addClass("highlight")
				$(test[index]).attr("data-index", index)
				try {
					$("body").animate({
						scrollTop: $(test[index]).offset().top
					}, 100)
				} catch(err) {
					index = 0
					$(test[index]).addClass("highlight")
					$(test[index]).attr("data-index", index)
					$("body").animate({
						scrollTop: $(test[index]).offset().top
					}, 100)
				}
			} catch(err) {}
		} else if(parsedJson["messagetype"] === "selectall") {
			bSelectAll = true
			$(document.body).find("span.found").replaceWith(function() {
				return $(this).text()
			})
			clearResults()
			if(parsedJson["regex"]) {
				try {
					$("body").findWord(searchTerm, bCaseSensitive, bSelectAll)
				} catch(err) {
					alert("Invalid Regular Expression")
				}
			} else {
				$("body").findWord(searchTerm, bCaseSensitive, bSelectAll)
			}

			$(document.body).find("span.found").addClass("highlight")

		}

	}
}

//Replace inline with <span> with background-color set to highlight color
$.fn.findWord = function(strKeyword, bCaseSensitive, bSelectAll) {
	var strMatchFlags = ""
	if(bSelectAll) {
		strMatchFlags = strMatchFlags.concat("g")
	}
	if(!bCaseSensitive) {
		strMatchFlags = strMatchFlags.concat("i")
	}
	/*col = $("table").find("tr:first").children().length;
	if (col === 0){
		var elemToFind = 'nobr';
	}
	else {
		var elemToFind = 'table td:nth-child(' + col + ')'
	}*/
	var elemToFind = "body"
	return $(elemToFind).VPFind(strKeyword, {
		"strMatchFlags": strMatchFlags
	})
}

function VPFind($context_, keyword_, options_) {
	// Initialize options
	this.options = $.extend({}, {
		"debug": false,
		"element": "span",
		"className": "found",
		"filter": []
	}, options_)
	// Initialize keyword
	this.keyword = typeof keyword_ === "string" ? keyword_ : ""
	// Initialize elements
	this.$elements = $()
	if($context_ instanceof $ && $context_.length > 0) {
		this.$elements = $context_.add($context_.find("*"))
		// Filter elements if filter is defined
		var tmp = this.getFilteredElements()
		if(tmp != false) {
			this.$elements = tmp
		}
	}
	return this
}
/**
 * Filters elements based on the
 * defined filter and saves the result
 * in the elements variable
 * 
 * @return jquery-object
 */
VPFind.prototype.getFilteredElements = function() {
	var filterArr = this.options["filter"]
	if(typeof filterArr !== "object" || this.$elements instanceof $ == false ||
			Object.prototype.toString.call(filterArr) != "[object Array]"
	) {
		return false
	}
	var $contextElements = this.$elements
	$contextElements = $contextElements.filter(function() {
		var $this = $(this)
		// Check if match in element itself
		var foundInElement = false
		for(var i = 0, ilength = filterArr.length; i < ilength; i++) {
			var filter = filterArr[i]
			// Use is() instead of hasClass() to
			// support complex selectors
			if($this.is(filter)) {
				foundInElement = true
				continue
			}
		}
		if(foundInElement) {
			// Delete entry
			return false
		} else {
			// Remain entry
			return true
		}
	})
	return $contextElements
}
/**
	 * Gets non recursive nodes of an element and returns
	 * it as an array
	 * 
	 * @param jquery-object $elements_
	 * @return array
	 */
VPFind.prototype.getTextNodes = function($elements_) {
	var arr = []
	if($elements_ instanceof $ == false || $elements_.length == 0) {
		return arr
	}
	// Iterate over all items in the stack
	$elements_.each(function() {
		var $this = $(this)
		//console.log($this);
		// Get all text nodes of this element (not recursive!)
		var $nodes = $this.contents().filter(function() {
			if(this.nodeType == 3) {
				return true
			} else {
				return false
			}
		})

		// Iterate over that text nodes and call callback
		$nodes.each(function() {
			arr.push(this)
		})
	})
	return arr
}

/**
 * Creates a regular expression
 * based on the current keyword
 * 
 * @param string keyword_ (optional if you don't want to use this.keyword)
 * @return string
 */
VPFind.prototype.getKeywordRegexp = function(keyword_) {
	var keyword = typeof keyword_ !== "string" ? this.keyword : keyword_
	if(typeof keyword !== "string" || keyword == "") {
		return keyword
	}
	var regexp = keyword
	return regexp
}
/**
	 * Highlighting
	 * 
	 * @param string keyword_ (optional, will be used for recursive calls)
	 * @return bool
	 */
VPFind.prototype.highlight = function(keyword_) {
	// If the keyword is a blank it is not a error because
	// the user does not expect that anything will be highlighted.
	// So we will still return true
	var keyword = typeof keyword_ !== "string" ? this.keyword : keyword_
	if(keyword == "") {
		return true
	}
	if(this.$elements.length == 0) {
		if(this.options["debug"]) {
			console.log("No search context provided")
		}
		return false
	}

	// Filter all elements that were already highlighted
	// (e.g. if separateWordSearch is true)
	//this.$elements = this.$elements.filter("*:not([data-VPFind])");

	if(this.options["debug"]) {
		console.log("Highlighting keyword '" + keyword + "' in elements:")
		console.log(this.$elements)
	}
	// Get the regular expression
	var regexp = this.getKeywordRegexp(keyword)
	// Build the expression to search in node values
	// Note: Don't search with the "g" flag: http://tinyurl.com/q5hdctj
	var nodeMatchRegex = new RegExp(regexp, "mi")
	// Iterate over all text nodes, find matches and replace
	// the search keyword with the highlighting element
	var textNodes = this.getTextNodes(this.$elements)
	for(var i = 0, length = textNodes.length; i < length; i++) {
		var node = textNodes[i]
		if(
			typeof node !== "object" ||
			typeof node.nodeValue !== "string" ||
			node.nodeValue.trim() == ""
		) {
			continue
		}
		if(nodeMatchRegex.test(node.nodeValue) === false) {
			continue
		}
		if(this.options["debug"]) {
			console.log("Regex: '" + regexp + "'. Node value: '" + node.nodeValue + "'")
		}
		var tagO = "<" + this.options["element"] + " class='" + this.options["className"] + "' style='" + this.options["style"] +
			"' data-VPFind='true'>"
		var tagC = "</" + this.options["element"] + ">"
		if(node.parentNode != null) {
			// Don't search inside HTML tags (e.g. keyword "data"
			// would match because of data-xyz inside HTML tag).
			// Replace it with the original match, e.g. if the 
			// search keyword is "g" replace it with "g" and not "G"
			var regex = new RegExp("((?![^<]*>)" + regexp + ")", this.options["strMatchFlags"])
			node.parentNode.innerHTML = node.parentNode.innerHTML.replace(
				regex,
				tagO + "$1" + tagC
			)
		}
	}
	return true
}
/**
 * Will append the domElement with previous
 * or next elements if they are text nodes
 * or also highlighting elements. This prevents
 * that the highlight removal will split text nodes.
 * 
 * @param jquery-object $domElement
 * @param jquery-object $stack
 * @return bool
 */
VPFind.prototype.appendTextNodes = function($domElement, $stack) {
	if($domElement instanceof $ == false || $domElement.length == 0) {
		return false
	}

	var domElement = $domElement.first()[0]
	var prevSibling = domElement.previousSibling
	var nextSibling = domElement.nextSibling
	var $prevSibling = $(prevSibling)
	var $nextSibling = $(nextSibling)

	var handled = false
	// Check if there is a previous text node or
	// highlight element. If so, append those two elements
	// with the text content
	if($prevSibling.length > 0) {
		if(prevSibling.nodeType == 3) {
			// It's a text node
			prevSibling.nodeValue = prevSibling.nodeValue + $domElement.text()
			$domElement.remove()
		} else if($stack instanceof $ && $stack.length > 0 && $stack.is($prevSibling)) {
			// It's another highlighting element
			$prevSibling.replaceWith($domElement.text() + $prevSibling.text())
			$domElement.remove()
		} else {
			$domElement.replaceWith($domElement.text())
		}
		handled = true
	}

	// Check if there is a next text node or
	// highlight element. If so, append those two elements
	// with the text node
	if($nextSibling.length > 0) {
		if(nextSibling.nodeType == 3) {
			if($prevSibling.length == 0) {
				nextSibling.nodeValue = $domElement.text() + nextSibling.nodeValue
				$domElement.remove()
			} else {
				nextSibling.nodeValue = $prevSibling.text() + nextSibling.nodeValue
				$prevSibling.remove()
			}
		} else if($stack instanceof $ && $stack.length > 0 && $stack.is($nextSibling)) {
			if($prevSibling.length == 0) {
				$nextSibling.replaceWith($nextSibling.text() + $domElement.text())
				$domElement.remove()
			} else {
				$nextSibling.replaceWith($prevSibling.text() + $nextSibling.text())
				$prevSibling.remove()
			}
		} else {
			if($prevSibling.length == 0) {
				$domElement.replaceWith($domElement.text())
			}
		}
		handled = true
	}

	// If there is no next or prev element
	// simply remove the element with it's content
	if(handled == false) {
		$domElement.replaceWith($domElement.text())
	}

	return true
}

/**
 * VPFind component exposure for jQuery
 * 
 * @return boolean
 */
$.fn.VPFind = function(keyword_, options_) {
	var highlightInstance = new VPFind($(this), keyword_, options_)
	return highlightInstance.highlight()
}
RegExp.escape = function(s) {
	return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&")
}

function buildSearchTerm(searchTerm1, operator1, searchTerm2, operator2, searchTerm3, wholeword, regex) {
	var builtTerm
	var advTerm
	var strWordBound = ""
	if(wholeword == 1) {
		strWordBound = "\\b"
	}
	if(searchTerm1 === "") {
		builtTerm = ""
	} else if(searchTerm2 !== "" && searchTerm3 !== "") {
		if(!regex) {
			searchTerm1 = RegExp.escape(searchTerm1)
			searchTerm2 = RegExp.escape(searchTerm2)
			searchTerm3 = RegExp.escape(searchTerm3)
		}
		searchTerm1 = strWordBound + searchTerm1 + strWordBound
		searchTerm2 = strWordBound + searchTerm2 + strWordBound
		searchTerm3 = strWordBound + searchTerm3 + strWordBound
		advTerm = getAdvancedTerm(searchTerm2, searchTerm3, operator2)
		builtTerm = getAdvancedTerm(searchTerm1, advTerm, operator1)
	} else if(searchTerm2 !== "") {
		if(!regex) {
			searchTerm1 = RegExp.escape(searchTerm1)
			searchTerm2 = RegExp.escape(searchTerm2)
		}
		searchTerm1 = strWordBound + searchTerm1 + strWordBound
		searchTerm2 = strWordBound + searchTerm2 + strWordBound
		builtTerm = getAdvancedTerm(searchTerm1, searchTerm2, operator1)
	} else {
		if(!regex) {
			searchTerm1 = RegExp.escape(searchTerm1)
		}
		builtTerm = strWordBound + searchTerm1 + strWordBound
	}

	return builtTerm
}

function getAdvancedTerm(termA, termB, operand) {
	var returnString
	switch(operand) {
	case "undefined":
		returnString = ""
		break

	case "adj":
		returnString = termA + "[ ]*" + termB + "|" + termB + "[ ]*" + termA
		break

	case "near2":
		returnString = termA + "[ ]*[^\\s]*[ ]{0,1}" + termB + "|" + termB + "[ ]*[^\\s]*[ ]{0,1}" + termA
		break

	case "near3":
		returnString = termA + "[ ]*[^\\s]*[ ]{0,1}[^\\s]*[ ]{0,1}" + termB + "|" + termB + "[ ]*[^\\s]*[ ]{0,1}[^\\s]*[ ]{0,1}" + termA
		break

	case "near4":
		returnString = termA + "[ ]*[^\\s]*[ ]{0,1}[^\\s]*[ ]{0,1}[^\\s]*[ ]{0,1}" + termB + "|" + termB + "[ ]*[^\\s]*[ ]{0,1}[^\\s]*[ ]{0,1}[^\\s]*[ ]{0,1}" + termA
		break

	case "and":
		returnString = termA + ".*" + termB + "|" + termB + ".*" + termA
		break

	case "or":
		returnString = termA + "|" + termB
		break

	case "andnot":
		returnString = termA + "(?!" + termB + ")" //need to get negative lookbehind for case of termB before termA
		break

	case "ornot":
		returnString = termA + "|" + termB //this doesn't really make sense on the record view, seems to just find each char
		break

	case "followedadj":
		returnString = termA + "[ ]*" + termB
		break

	case "followednear2":
		returnString = termA + "[ ]*[^\\s]*[ ]{0,1}" + termB
		break

	case "followednear3":
		returnString = termA + "[ ]*[^\\s]*[ ]{0,1}[^\\s]*[ ]{0,1}" + termB
		break

	case "followednear4":
		returnString = termA + "[ ]*[^\\s]*[ ]{0,1}[^\\s]*[ ]{0,1}[^\\s]*[ ]{0,1}" + termB
		break

	case "followedand":
		returnString = termA + ".*" + termB
		break
	}
	return returnString
}

function clearResults() {
	$("td, span").each(function() {
		$(this).html($(this).html())
	})
}